import * as React from 'react'
import isEmail from 'validator/lib/isEmail'

import { t } from '@owl-nest/localize'

import { PasswordFeedback } from './useNewPasswordValidator'
import { RequestFailure } from '@owl-nest/api-client'
import { ApiError } from '@owl-nest/api-client/latest'

export function validateNewPassword(
  queryFeedback: (password: string) => Promise<PasswordFeedback | undefined>,
): (password: string) => Promise<string | undefined> {
  return async (password) => {
    const feedback = await queryFeedback(password)
    if (feedback && (feedback.score === 'worst' || feedback.score === 'bad')) {
      return 'error'
    }
  }
}

export function validateEmail(email: string): string | undefined {
  if (!isEmail(email)) {
    return t('Enter a valid email address')
  }
}

export function validateRequired(value: any): string | undefined {
  if (!value) {
    return t('This field is required')
  }
}

export function apiErrorGetter<FORM>(
  failure?: RequestFailure,
): (messages: { [K in keyof FORM]?: { [s: string]: React.ReactNode | undefined } }) => (
  field: keyof FORM & string,
) => React.ReactNode {
  const classifications: { [s: string]: string | undefined } = {}
  if (failure && failure.status === 422) {
    const apiError: ApiError = failure.body
    for (const error of apiError) {
      for (const field of error.fieldNames) {
        classifications[field] = error.classification
      }
    }
  }
  if (failure && failure.status === 401) {
    classifications['password'] = failure.body?.type
  }

  return (messages) => {
    return (field) => {
      const fieldClassification = classifications[field]
      const fieldMessages = messages[field]
      if (fieldClassification === undefined || fieldMessages === undefined) {
        return undefined
      }
      return fieldMessages[fieldClassification]
    }
  }
}
